// extracted by mini-css-extract-plugin
export default {"dropdownWrapper":"settingsFormDropdown_dropdownWrapper__glypU","dropdownList":"settingsFormDropdown_dropdownList__btI0d"};